export const ReleaseCitySubdivisionSourceValue = {
  Manual: 'manual',
  AddressHeuristic: 'addressHeuristic',
  Ai: 'ai',
  LogistCity: 'logistCity',
  InstallerSubdivision: 'installerSubdivision',
} as const;

export type ReleaseCitySubdivisionSource =
  (typeof ReleaseCitySubdivisionSourceValue)[keyof typeof ReleaseCitySubdivisionSourceValue];

// Sources ranked below AI: an AI result replaces them
export const AiReplaceableReleaseCitySources: readonly ReleaseCitySubdivisionSource[] =
  [
    ReleaseCitySubdivisionSourceValue.LogistCity,
    ReleaseCitySubdivisionSourceValue.InstallerSubdivision,
  ];
